import { ButtonToolbar, Dropdown, DropdownButton } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react'
import { useRouteMatch, useLocation } from 'react-router-dom'
import {
  createAndUpdate,
  deleteData,
  getData,
  postData,
  putData,
} from '../Action'
import { DesignContext } from 'contexts/DesignContext'
import { useContext } from 'react'
import useAuth from 'hooks/useAuth'

const SelectionButton = ({
  showSelectionButton,
  uischema,
  rowSelection,
  renderTableData,
}) => {
  const designContext = useContext(DesignContext)
  const match = useRouteMatch()
  const location = useLocation()
  const { user } = useAuth()
  let receivePathParams = match.params
  let urlSearchParams = new URLSearchParams(location.search || [])
  let receiveQueryParams = Object.fromEntries([...urlSearchParams])
  let allParams = { ...receivePathParams, ...receiveQueryParams }

  const handleSelectionAction = async (selection, rowData) => {
    if (selection.action === 'getData') {
      await getData({
        action: selection,
        rowData,
        designContext,
        renderTableData,
        allParams,
      })
    } else if (selection.action === 'postData') {
      await postData({
        action: selection,
        rowData,
        designContext,
        renderTableData,
        allParams,
        user,
        uischema,
      })
    } else if (selection.action === 'putData') {
      await putData({
        action: selection,
        rowData,
        designContext,
        renderTableData,
        allParams,
        user,
        uischema,
      })
    } else if (selection.action === 'deleteData') {
      await deleteData({
        action: selection,
        rowData,
        designContext,
        renderTableData,
        allParams,
        uischema,
        user,
      })
    } else if (selection.action === 'createAndUpdate') {
      await createAndUpdate({
        action: selection,
        rowData,
        designContext,
        renderTableData,
        allParams,
        user,
      })
    }
  }

  return (
    <ButtonToolbar>
      <DropdownButton
        title={'จัดการรายการ'}
        variant={'outline-secondary'}
        id={`dropdown-variants-info`}
        key="selection"
        className="text-capitalize mr-0 ml-auto"
      >
        {(showSelectionButton?.action || []).map((item, index) => {
          return (
            <Dropdown.Item
              key={`selection-${index + 1}`}
              eventKey={`selection-${index + 1}`}
              onClick={() => handleSelectionAction(item, rowSelection)}
            >
              {item.icon && (
                <FeatherIcon size="14" icon={item.icon} className="mr-1" />
              )}
              {item.name}
            </Dropdown.Item>
          )
        })}
      </DropdownButton>
    </ButtonToolbar>
  )
}

export default SelectionButton
